(function () {

  'use strict';


  /* =====================================================
     INITIALIZE SECTION
  ===================================================== */

  function initVSShopByBudget(section) {

    if (!section) {
      return;
    }


    if (
      section.dataset.vsBudgetInitialized === 'true'
    ) {
      return;
    }


    section.dataset.vsBudgetInitialized = 'true';


    const track =
      section.querySelector(
        '[data-vs-budget-track]'
      );


    if (!track) {
      return;
    }


    /* ===================================================
       DESKTOP DRAG SCROLL
    =================================================== */

    let isDragging = false;

    let startX = 0;

    let startScrollLeft = 0;


    track.addEventListener(
      'mousedown',
      function (event) {

        if (
          track.scrollWidth <=
          track.clientWidth
        ) {
          return;
        }


        isDragging = true;

        startX =
          event.pageX -
          track.offsetLeft;

        startScrollLeft =
          track.scrollLeft;

        track.style.cursor =
          'grabbing';

      }
    );


    track.addEventListener(
      'mousemove',
      function (event) {

        if (!isDragging) {
          return;
        }


        event.preventDefault();


        const currentX =
          event.pageX -
          track.offsetLeft;


        const distance =
          (currentX - startX) * 1.2;


        track.scrollLeft =
          startScrollLeft - distance;

      }
    );


    function stopDragging() {

      isDragging = false;

      track.style.cursor = '';

    }


    track.addEventListener(
      'mouseup',
      stopDragging
    );


    track.addEventListener(
      'mouseleave',
      stopDragging
    );


    /* ===================================================
       TOUCH SUPPORT
    =================================================== */

    let touchStartX = 0;

    let touchStartScroll = 0;


    track.addEventListener(
      'touchstart',
      function (event) {

        if (
          !event.touches ||
          !event.touches.length
        ) {
          return;
        }


        touchStartX =
          event.touches[0].pageX;

        touchStartScroll =
          track.scrollLeft;

      },
      {
        passive: true
      }
    );


    track.addEventListener(
      'touchmove',
      function (event) {

        if (
          !event.touches ||
          !event.touches.length
        ) {
          return;
        }


        const currentX =
          event.touches[0].pageX;


        const distance =
          touchStartX - currentX;


        if (
          Math.abs(distance) > 5
        ) {

          track.scrollLeft =
            touchStartScroll + distance;

        }

      },
      {
        passive: true
      }
    );


    /* ===================================================
       MOUSE WHEEL → HORIZONTAL SCROLL
    =================================================== */

    track.addEventListener(
      'wheel',
      function (event) {

        if (
          window.innerWidth <= 749
        ) {
          return;
        }


        if (
          track.scrollWidth <=
          track.clientWidth
        ) {
          return;
        }


        if (
          Math.abs(event.deltaY) >
          Math.abs(event.deltaX)
        ) {

          event.preventDefault();

          track.scrollLeft +=
            event.deltaY;

        }

      },
      {
        passive: false
      }
    );


    /* ===================================================
       PREVENT IMAGE DRAG
    =================================================== */

    const images =
      track.querySelectorAll(
        'img'
      );


    images.forEach(
      function (image) {

        image.addEventListener(
          'dragstart',
          function (event) {

            event.preventDefault();

          }
        );

      }
    );


    /* ===================================================
       KEYBOARD ACCESSIBILITY
    =================================================== */

    track.setAttribute(
      'tabindex',
      '0'
    );


    track.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key !== 'ArrowLeft' &&
          event.key !== 'ArrowRight'
        ) {
          return;
        }


        event.preventDefault();


        const firstCard =
          track.querySelector(
            '.vs-shop-by-budget__card'
          );


        if (!firstCard) {
          return;
        }


        const cardWidth =
          firstCard.getBoundingClientRect().width;


        const gap =
          parseFloat(
            window.getComputedStyle(track).gap
          ) || 10;


        const scrollAmount =
          cardWidth + gap;


        if (
          event.key === 'ArrowRight'
        ) {

          track.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
          });

        }


        if (
          event.key === 'ArrowLeft'
        ) {

          track.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
          });

        }

      }
    );

  }


  /* =====================================================
     INITIALIZE ALL SECTIONS
  ===================================================== */

  function initializeVSShopBudget() {

    const sections =
      document.querySelectorAll(
        '[data-vs-budget-section]'
      );


    sections.forEach(
      function (section) {

        initVSShopByBudget(section);

      }
    );

  }


  /* =====================================================
     DOCUMENT READY
  ===================================================== */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeVSShopBudget
    );

  } else {

    initializeVSShopBudget();

  }


  /* =====================================================
     SHOPIFY THEME EDITOR
  ===================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      if (
        !event.detail ||
        !event.detail.sectionId
      ) {
        return;
      }


      const section =
        document.getElementById(
          'vs-shop-by-budget-' +
          event.detail.sectionId
        );


      if (section) {

        initVSShopByBudget(section);

      }

    }
  );


  /* =====================================================
     SHOPIFY SECTION REORDER
  ===================================================== */

  document.addEventListener(
    'shopify:section:reorder',
    function () {

      initializeVSShopBudget();

    }
  );


})();